(() => {
  'use strict';
  const route = path => `${window.Shopify?.routes?.root || window.Tizico?.rootUrl || '/'}${path}`;
  let drawer, opener, busy = false, refreshVersion = 0;
  const strings = () => window.Tizico?.strings || {};
  function lock() { document.body.classList.toggle('cart-modal-open', !!document.querySelector('dialog[open]')); }
  function close(dialog) { dialog.close(); }
  function setBusy(value) {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-drawer-quantity], [name="checkout"]').forEach(el => { el.disabled = value; });
  }
  async function refresh() {
    const version = ++refreshVersion;
    const response = await fetch(`${route('')}?sections=cart-drawer`, { headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error('cart');
    const sections = await response.json();
    if (typeof sections['cart-drawer'] !== 'string') throw new Error('section');
    const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const content = html.querySelector('[data-cart-drawer-content]');
    if (!content) throw new Error('content');
    if (version !== refreshVersion) return;
    drawer.querySelector('[data-cart-drawer-content]').replaceWith(content);
    const count = content.querySelector('[data-drawer-count]');
    if (count) {
      const badge = document.getElementById('cart-count');
      if (badge) badge.textContent = count.dataset.drawerCount;
      document.getElementById('cart-open')?.setAttribute('aria-label', count.dataset.drawerCartLabel);
    }
  }
  async function openCart() {
    if (!drawer || busy) return;
    opener = document.activeElement;
    if (!drawer.open) drawer.showModal();
    lock();
    const status = drawer.querySelector('[data-cart-drawer-status]');
    status.textContent = drawer.dataset.loadingText;
    setBusy(true);
    let confirmed = false;
    try { await refresh(); confirmed = true; status.textContent = ''; }
    catch (error) { console.warn('Tizico cart refresh:', error.message); status.textContent = drawer.dataset.errorText; }
    finally { setBusy(false); if (!confirmed) drawer.querySelectorAll('[name="checkout"]').forEach(button => { button.disabled = true; }); }
  }
  async function changeLine(key, quantity) {
    if (busy || !Number.isInteger(quantity) || quantity < 0) return;
    setBusy(true);
    const status = drawer.querySelector('[data-cart-drawer-status]');
    status.textContent = drawer.dataset.loadingText;
    let confirmed = false;
    try {
      const response = await fetch(route('cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || drawer.dataset.updateError);
      await refresh();
      confirmed = true;
      status.textContent = '';
    } catch { status.textContent = drawer.dataset.updateError; }
    finally {
      setBusy(false);
      if (!confirmed) drawer.querySelectorAll('[name="checkout"]').forEach(button => { button.disabled = true; });
    }
  }
  function initProduct(section) {
    if (section.dataset.essentialsReady) return;
    section.dataset.essentialsReady = 'true';
    const select = section.querySelector('[data-variant-select]');
    const form = section.querySelector('[data-tizico-product-form]');
    const choices = section.querySelector('[data-variant-buttons]');
    if (choices) choices.hidden = false;
    if (select && (choices || select.options.length === 1)) select.closest('.product-variant-field').hidden = true;
    const sync = () => {
      const button = section.querySelector('[data-product-submit]');
      const pending = form?.getAttribute('aria-busy') === 'true';
      const unavailable = button?.disabled;
      const buyNow = section.querySelector('[data-buy-now]');
      if (buyNow) buyNow.disabled = pending || unavailable;
      const sticky = section.querySelector('[data-sticky-add]');
      if (sticky) { sticky.disabled = pending || unavailable; sticky.textContent = pending ? strings().adding : section.querySelector('[data-add-label]')?.textContent; }
      const price = section.querySelector('[data-sticky-price]');
      if (price) price.textContent = section.querySelector('[data-product-price]')?.textContent;
      section.querySelectorAll('[data-variant-choice]').forEach(choice => { choice.setAttribute('aria-pressed', String(choice.dataset.variantChoice === select?.value)); choice.disabled = pending; });
      const express = section.querySelector('[data-product-express]');
      if (express) express.hidden = pending || unavailable;
      const stock = section.querySelector('[data-product-stock]');
      if (stock && !pending) stock.textContent = unavailable ? strings().sold_out : stock.dataset.availableText;
    };
    section.addEventListener('tizico:variant-changed', sync);
    if (form) new MutationObserver(sync).observe(form, { attributes: true, attributeFilter: ['aria-busy'] });
    sync();
    const row = section.querySelector('.product-purchase-row');
    const bar = section.querySelector('[data-mobile-purchase]');
    if (row && bar && 'IntersectionObserver' in window) new IntersectionObserver(entries => { bar.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0; }).observe(row);
    const zoom = section.querySelector('[data-zoom-dialog]');
    if (zoom) {
      zoom.addEventListener('close', () => { lock(); opener?.focus(); });
      zoom.addEventListener('click', event => { if (event.target === zoom || event.target.closest('[data-zoom-close]')) close(zoom); });
    }
    const gallery = section.querySelector('[data-product-gallery]');
    let touch;
    gallery?.addEventListener('touchstart', event => { const point = event.touches[0]; touch = { x: point.clientX, y: point.clientY }; }, { passive: true });
    gallery?.addEventListener('touchend', event => {
      if (!touch || event.target.closest('video, iframe, button')) return;
      const point = event.changedTouches[0], dx = point.clientX - touch.x, dy = point.clientY - touch.y;
      touch = null;
      if (Math.abs(dx) < 60 || Math.abs(dx) < Math.abs(dy)) return;
      const thumbs = [...section.querySelectorAll('[data-gallery-select]')];
      const index = thumbs.findIndex(item => item.getAttribute('aria-pressed') === 'true');
      thumbs[(index + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length]?.click();
    }, { passive: true });
  }
  function init() {
    drawer = document.getElementById('tizico-cart-drawer');
    drawer?.addEventListener('close', () => { lock(); opener?.focus(); });
    document.querySelectorAll('[data-tizico-product]').forEach(initProduct);
    document.addEventListener('tizico:cart-added', openCart);
    document.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      if (target.closest('#cart-open') && drawer && !event.ctrlKey && !event.metaKey && !event.shiftKey) { event.preventDefault(); openCart(); }
      if (drawer?.open && (target === drawer || target.closest('[data-cart-close]'))) close(drawer);
      const remove = target.closest('[data-drawer-remove]');
      if (remove) { event.preventDefault(); changeLine(remove.dataset.lineKey, 0); }
      const choice = target.closest('[data-variant-choice]');
      if (choice) { const select = choice.closest('[data-tizico-product]').querySelector('[data-variant-select]'); select.value = choice.dataset.variantChoice; select.dispatchEvent(new Event('change', { bubbles: true })); }
      const image = target.closest('[data-product-zoom]');
      if (image) {
        const dialog = image.closest('[data-tizico-product]').querySelector('[data-zoom-dialog]');
        if (!dialog) return;
        event.preventDefault(); opener = image;
        const zoomImage = dialog.querySelector('[data-zoom-image]'); zoomImage.src = image.href; zoomImage.alt = image.querySelector('img')?.alt || '';
        dialog.showModal(); lock();
      }
    });
    document.addEventListener('change', event => {
      const input = event.target;
      if (input.matches('[data-drawer-quantity]') && input.reportValidity()) changeLine(input.dataset.lineKey, Number(input.value));
    });
    document.addEventListener('shopify:section:load', () => document.querySelectorAll('[data-tizico-product]').forEach(initProduct));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
